import { Typography } from "../components/atoms/Typography";
import { useAuthSession } from "../contexts/AuthSessionContext";

export const ProfilePage = () => {
  const { user, effectiveAccess, matchedGroups } = useAuthSession();

  return (
    <section className="page-section max-w-3xl">
      <header className="page-header mb-6">
        <Typography as="h1" variant="h1">
          Profile
        </Typography>
        <p className="page-subtitle mt-1 text-sm text-gray-600">
          Your account details from the last sign-in verification.
        </p>
      </header>
      <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <dl className="space-y-3 text-sm">
          <div>
            <dt className="font-medium text-gray-500">Name</dt>
            <dd className="text-gray-900">{user?.name ?? "—"}</dd>
          </div>
          <div>
            <dt className="font-medium text-gray-500">Email</dt>
            <dd className="text-gray-900">{user?.email ?? "—"}</dd>
          </div>
          <div>
            <dt className="font-medium text-gray-500">User id</dt>
            <dd className="font-mono text-xs text-gray-900">{user?.id ?? "—"}</dd>
          </div>
          <div>
            <dt className="font-medium text-gray-500">Decision role</dt>
            <dd className="text-gray-900">{effectiveAccess?.decision_role_code ?? "—"}</dd>
          </div>
          <div>
            <dt className="font-medium text-gray-500">Business units</dt>
            <dd className="text-gray-900">
              {(effectiveAccess?.business_unit_codes ?? []).join(", ") || "—"}
            </dd>
          </div>
          <div>
            <dt className="font-medium text-gray-500">Groups</dt>
            <dd className="text-gray-900">
              {matchedGroups.length > 0 ? matchedGroups.join(", ") : "—"}
            </dd>
          </div>
        </dl>
      </div>
    </section>
  );
};
